import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';

function useUploadProgress() {
  const {
    uploadRequirements,
    uploadProgressSummary,
    uploadProgressByCategory,
    refreshUploadProgress,
    schoolsUploadProgressByCategory,
  } = useContext(GlobalStateContext);

  return {
    uploadRequirements,
    uploadProgressSummary,
    uploadProgressByCategory,
    refreshUploadProgress,
    schoolsUploadProgressByCategory,
  };
}

export default useUploadProgress;
